"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.h2(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  font-style: normal;\n  font-size: 36px;\n  line-height: 42px;\n  font-feature-settings: \"pnum\" on, \"lnum\" on;\n  color: ", ";\n  position: relative;\n\n  &.with-bold-text {\n    span {\n      font-family: ", ";\n    }\n  }\n\n  &.product-name-header {\n    font-size: 24px;\n    line-height: 36px;\n    font-weight: 500;\n    letter-spacing: -0.015em;\n    color: ", ";\n  }\n\n  &.retailer-name-header {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 19px;\n    color: ", ";\n  }\n\n  &.input-name-header {\n    font-size: 14px;\n    line-height: 19px;\n    height: 19px;\n    max-width: 100%;\n    font-weight: 400;\n    color: ", ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &.date-header {\n    font-family: ", ";\n    color: ", ";\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 18px;\n  }\n\n  &.table-row-text {\n    font-family: ", ";\n    color: ", ";\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 18px;\n\n    &:last-child {\n      min-width: 50px;\n      text-align: center;\n    }\n  }\n\n  &.gray-table-row {\n    font-family: ", ";\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 19px;\n    color: ", ";\n    background-color: ", ";\n    padding: 1px 3px;\n    border-radius: 3px;\n    min-width: 50px;\n    text-align: center;\n  }\n  &.header-and-paragraph {\n    font-family: ", ";\n    font-size: 36px;\n    color: ", ";\n    p {\n      font-family: ", ";\n      font-size: 14px;\n      color: ", ";\n      letter-spacing: -0.015em;\n    }\n  }\n"])), function (props) {
  return props.fontFamily;
}, function (props) {
  return props.color;
}, _variables.FontFamily.Raleway_700, function (_ref) {
  var color = _ref.color;
  return color ? color : _variables.GlobalColors.secondary_magenta;
}, function (_ref2) {
  var color = _ref2.color;
  return color ? color : _variables.GlobalColors.s5;
}, function (_ref3) {
  var color = _ref3.color;
  return color ? color : _variables.GlobalColors.s5;
}, _variables.FontFamily.AvenirNext, function (_ref4) {
  var color = _ref4.color;
  return color ? color : _variables.GlobalColors.s4;
}, _variables.FontFamily.AvenirNext, function (_ref5) {
  var color = _ref5.color;
  return color ? color : _variables.GlobalColors.s4;
}, _variables.FontFamily.AvenirNext, function (_ref6) {
  var color = _ref6.color;
  return color ? color : _variables.GlobalColors.s5;
}, _variables.GlobalColors.s2, _variables.FontFamily.Raleway, _variables.GlobalColors.s5, _variables.FontFamily.AvenirNext, _variables.GlobalColors.s4);

exports.Container = Container;